// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2Nwtp","insightsList":"newBusinessInsightsMenu_insightsList__1VpJ1","active":"newBusinessInsightsMenu_active__3ZkLy"};